import {
  IconButton,
  Modal,
  Box,
  Typography,
  Grid,
  Divider,
  TextField,
  MenuItem,
  Button,
  FormControl,
  InputLabel,
  Select,
  Stack,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
// import IconButton from "@mui/material/IconButton";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
// import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { DataGrid, GridToolbar, GridToolbarColumnsButton, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton, GridToolbarQuickFilter } from "@mui/x-data-grid";
import MDBox from "components/MDBox";
import FilterBar from "examples/FilterBar/FilterBar";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Edit } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import EditCreditLimitDialog from "./EditCreditLimitDialog";
import EditCreditNoteDialog from "./EditCreditNoteDialog";
import EditTDSDialog from "./EditTDSDialog";
import { useEffect } from "react";
import Tooltip from "@mui/material/Tooltip";
import { hospitalBranch } from "services/hospitalServices";
import { HospitalBranchList } from "layouts/hospital/Redux/actionCreator";
import moment from "moment";
import { UpdateHospital } from "../hospital/Redux/actionCreator";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import DetailsDialog from "./DetailsDialog";

const LocumCreditLimit = () => {
  const { state } = useLocation();
  const dispatch = useDispatch();

  const [openModal, setOpenModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showSnackbar, setShowSnackbar] = useState(false);

  const [openConfirm, setOpenConfirm] = useState(false);
  const [selectedRowMode, setSelectedRowMode] = useState(null);
  const [newMode, setNewMode] = useState("");
  const [confirmMessage, setConfirmMessage] = useState("");


const { adminData } = useSelector((state) => ({
    adminData: state?.auth?.adminData
  }));
  function CreditId(params) {
    // console.log("1-> ", params);
    var a;
    var rowName = params?.row?._id;
    // console.log("2-> ", rowName);
    return rowName;
    // if (rowName) {
    //   console.log("3-> ", `${a}`);
    //   return `${a}`;
    // } else {
    //   a = "NA";
    //   return `${a}`;
    // }
  }

  function getBranchName(params) {
    var a;
    var rowName = params?.row?.jobLocation?.branchName;
    return rowName;
    // if (rowName) {
    //   return `${a}`;
    // } else {
    //   a = "NA";
    //   return `${a}`;
    // }
  }

  function getBillingMode(params) {
    var rowName = params?.row?.billingInfo?.billingMode;
    return rowName;
  }
  function getBillingCycle(params) {
    var rowName = params?.row?.billingInfo?.billingCycle;
    return rowName;
  }

  function getPaymentDuePeriod(params) {
    var rowName = params?.row?.billingInfo?.paymentDuePeriodDays;
    return rowName;
  }

  function getBufferDays(params) {
    var rowName = params?.row?.billingInfo?.bufferDays;
    return rowName;
  }

  function getCreditThreshold(params) {
    var rowName = params?.row?.creditThresholdPercent;
    return rowName;
  }

  function getLatePaymentFee(params) {
    var rowName = params?.row?.latePaymentFeePercent;
    return rowName;
  }

  function getServiceFee(params) {
    var rowName = params?.row?.billingInfo?.serviceFeePercent;
    return rowName;
  }
  
   function getPlatformFee(params) {
     var rowName = params?.row?.billingInfo?.platformFeePercent;
     return rowName;
   }
  function getLimit(params) {
    var a;
    var rowName = params?.row?.creditLimit;
    return rowName;
    // if (rowName) {
    //   return `${a}`;
    // } else {
    //   a = "NA";
    //   return `${a}`;
    // }
  }

  function getRLimit(params) {
    // var a;
    var rowName = params?.row?.utilizedLimit;
    return rowName;
    // if (rowName) {
    //   return `${a}`;
    // } else {
    //   a = "NA";
    //   return `${a}`;
    // }
  }

  function getCreditNote(params) {
    var rowName = params?.row?.creditNote;
    return rowName;
  }

  function getRemainingAmount(params) {
    let creditLimit = params?.row?.creditLimit;
    let utilizedLimit = params?.row?.utilizedLimit;
    let creditNote = params?.row?.creditNote;
    let remainingAmount = creditLimit - utilizedLimit + creditNote;
    return remainingAmount;
    //  var rowName = params?.row?.creditNote;
    //  return rowName;
  }

  function getTDS(params) {
    var a;
    var rowName = params?.row?.tds;
    // const b = "%";
    // return rowName + b;
    return rowName;
  }

  function getCreatedAT(params) {
    var a;
    var rowName = params?.row?.createdAt;
    if (rowName) {
      a = moment(rowName).format("YYYY/MM/DD");
      return `${a}`;
    } else {
      a = "NA";
      return `${a}`;
    }
  }

  function getUpdatedAT(params) {
    var a;
    var rowName = params?.row?.updatedAt;
    if (rowName) {
      a = moment(rowName).format("YYYY/MM/DD");
      return `${a}`;
    } else {
      a = "NA";
      return `${a}`;
    }
  }

  const columns = [
    {
      field: "_id",
      headerName: `ID`,
      renderCell: (cellValues) => {
        const rowID = cellValues?.row?._id;
            const rowCode = cellValues?.row?.billNumber;
                const rowId = cellValues?.row?._id;
                //  console.log("rowCode-->", rowCode)
                //   console.log("rowId-->", rowId)
        
                // return <Link to={`/locumBill/billDetails/${rowId}`}>{rowCode}</Link>;
        // return (
        //   <Link to={`/creditLimit/creditLimit/managecredits/${rowId}`}>
        //     {rowID}
        //   </Link>
        // );
        return rowID;
      },
      flex: 1.2,
      valueGetter: CreditId,
    },
    {
      field: "branchName",
      headerName: `Branch Name`,
      renderCell: (cellValues) => {
        // console.log(cellValues);
        const branchName = cellValues?.row?.jobLocation?.branchName;
        // return branchName;
        return (
          <Tooltip title={branchName} arrow>
            {/* <div>{branchName}</div> */}
            <Link to={`/hospital/branch/${cellValues?.row?._id}`}>
              {branchName}
            </Link>
          </Tooltip>
        );
      },
      flex: 1.2,
      valueGetter: getBranchName,
    },
    // {
    //   field: "billingMode",
    //   headerName: `Payment Mode`,
    //   renderCell: (cellValues) => {
    //     // console.log(cellValues);
    //     const billingMode = cellValues?.row?.billingInfo?.billingMode;
    //     return billingMode;
    //     //give two options POSPAID and PREPAID and this is a dropdown editable
    //   },
    //   flex: 1.2,
    //   valueGetter: getBillingMode,
    // },

    {
      field: "billingMode",
      headerName: "Payment Mode",
      flex: 1.5,
      valueGetter: getBillingMode,
      // renderCell: (params) => {
      //   const { row } = params;
      //   const currentMode = row?.billingInfo?.billingMode;

      //   const handleChange = async (e) => {
      //     const newBillingMode = e.target.value;

      //     const payload = {
      //       billingInfo: {
      //         ...row.billingInfo,
      //         billingMode: newBillingMode,
      //       },
      //     };

      //     try {
      //       const response = await dispatch(
      //         UpdateHospital({ id: row._id, payload })
      //       );
      //       if (response?.error) {
      //         console.error("Failed to update billing mode:", response.error);
      //       } else {
      //         // setShowSnackbar(true);
      //         dispatch(HospitalBranchList([]));
      //         // setTimeout(() => setShowSnackbar(false), 3000); // hide after 3s
      //       }
      //     } catch (error) {
      //       console.error("Error updating billing mode:", error);
      //     }
      //   };

      //   return (
      //     <FormControl fullWidth size="small" variant="outlined">
      //       <Select
      //         value={currentMode || ""}
      //         onChange={handleChange}
      //         IconComponent={null}
      //         displayEmpty
      //         renderValue={(selected) => (
      //           <Box
      //             sx={{
      //               display: "flex",
      //               alignItems: "center",
      //               justifyContent: "space-between",
      //               width: "100%",
      //             }}
      //           >
      //             <Typography
      //               fontSize={{ xs: "10px", sm: "11px", md: "12px" }}
      //               noWrap
      //             >
      //               {selected || "Select"}
      //             </Typography>
      //             <ArrowDropDownIcon
      //               fontSize="inherit"
      //               sx={{
      //                 fontSize: { xs: "12px", sm: "13px", md: "14px" },
      //                 color: "gray",
      //                 ml: 1,
      //               }}
      //             />
      //           </Box>
      //         )}
      //         sx={{
      //           fontSize: { xs: "10px", sm: "11px", md: "12px" },
      //           minWidth: 100,
      //           pr: 0,
      //         }}
      //       >
      //         <MenuItem value="POSTPAID">POSTPAID</MenuItem>
      //         <MenuItem value="PREPAID">PREPAID</MenuItem>
      //       </Select>
      //     </FormControl>
      //   );
      // },

      renderCell: (params) => {
        const { row } = params;
        const currentMode = row?.billingInfo?.billingMode;

        // const handleChange = (e) => {
        //   const selected = e.target.value;

        //   setSelectedRowMode(row);
        //   setNewMode(selected);
        //   setOpenConfirm(true); // open popup
        // };
        const handleChange = (e) => {
          const mode = e.target.value;
          setSelectedRowMode(row);
          setNewMode(mode);
          setOpenConfirm(true);

          // Set message ONCE before opening dialog
          const message =
            row?.billingInfo?.billingMode === "PREPAID" && mode === "POSTPAID"
              ? "Payment mode will be changed to Postpaid. If any remaining prepaid balance is available then it will be adjusted as negative credit utilized amount."
              : "Payment mode will be changed to Prepaid.";
          setConfirmMessage(message);

        };
        const handleConfirm = async () => {
          setOpenConfirm(false);
          // console.log("selectedRowMode", selectedRowMode);
          // console.log("newMode", selectedRowMode);
          const payload = {
            billingInfo: {
              ...selectedRowMode.billingInfo,
              billingMode: newMode,
            },
          };

          try {
            const response = await dispatch(
              UpdateHospital({ id: selectedRowMode._id, payload })
            );

            if (!response?.error) {
              dispatch(HospitalBranchList([]));
            }
          } catch (error) {
            console.error("Error updating billing mode:", error);
          }
        };

        const handleCancel = () => {
          setOpenConfirm(false);
          setNewMode("");
          setSelectedRowMode(null);
        };

       
        return (
          <>
            {/* Select dropdown */}
            <FormControl fullWidth size="small" variant="outlined">
              <Select
                value={currentMode || ""}
                onChange={handleChange}
                IconComponent={null}
                displayEmpty
                renderValue={(selected) => (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <Typography
                      fontSize={{ xs: "10px", sm: "11px", md: "12px" }}
                      noWrap
                    >
                      {selected || "Select"}
                    </Typography>
                    <ArrowDropDownIcon
                      fontSize="inherit"
                      sx={{
                        fontSize: { xs: "12px", sm: "13px", md: "14px" },
                        color: "gray",
                        ml: 1,
                      }}
                    />
                  </Box>
                )}
              >
                <MenuItem value="POSTPAID">POSTPAID</MenuItem>
                <MenuItem value="PREPAID">PREPAID</MenuItem>
              </Select>
            </FormControl>

            {/* Confirmation Dialog */}
            <Dialog
              open={openConfirm}
              onClose={handleCancel}
              transitionDuration={300}
              PaperProps={{
                elevation: 0,
                sx: {
                  boxShadow: "none",
                  borderRadius: "12px",
                  border: "1px solid #e0e0e0",
                },
              }}
              sx={{
                "& .MuiBackdrop-root": {
                  backdropFilter: "blur(0px)", 
                  backgroundColor: "rgba(0,0,0,0.05)",
                },
              }}
            >
              <DialogTitle>Confirm Change</DialogTitle>
              <DialogContent>
                <Typography>{confirmMessage}</Typography>
              </DialogContent>

              <DialogActions>
                <Button
                  onClick={handleCancel}
                  color="secondary"
                  sx={{
                    transition: "all 0.3s ease",
                    borderRadius: "8px",
                    padding: "6px 16px",
                    backgroundColor: "#f5f5f5",
                    color: "#333",
                    ":hover": {
                      backgroundColor: "#e0e0e0",
                      transform: "scale(0.98)", // slight press feel
                    },
                    ":active": {
                      transform: "scale(0.95)", // smooth click
                    },
                  }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleConfirm}
                  variant="contained"
                  color="primary"
                >
                  Confirm
                </Button>
              </DialogActions>
            </Dialog>

            {/* <Dialog
              open={openConfirm}
              onClose={handleCancel}
              hideBackdrop
              PaperProps={{
                sx: {
                  boxShadow: "none",

                  borderRadius: "16px",
                  padding: "10px",
                  border: "1px solid #e0e0e0",
                },
              }}
            >
              <DialogTitle
                sx={{ display: "flex", alignItems: "center", gap: 1 }}
              >
         
                <Typography fontWeight={600}>
                  Confirm Payment Mode Change
                </Typography>
              </DialogTitle>

              <DialogContent>
                <Typography sx={{ fontSize: "14px", color: "#555" }}>
                  {selectedRowMode?.billingInfo?.billingMode === "PREPAID" &&
                  newMode === "POSTPAID"
                    ? "Switching to Postpaid will adjust any remaining prepaid balance as negative credit utilized."
                    : "Are you sure you want to switch to Prepaid?"}
                </Typography>
              </DialogContent>

              <DialogActions sx={{ padding: "16px" }}>
                <Button
                  onClick={handleCancel}
                  color="inherit"
                  variant="outlined"
                  sx={{
                    backgroundColor: "#fff",
                    color: "#000",
                    borderColor: "#ccc",
                    ":hover": {
                      backgroundColor: "#f5f5f5",
                      borderColor: "#999",
                    },
                  }}
                >
                  Cancel
                </Button>

                <Button
                  onClick={handleConfirm}
                  variant="contained"
                  sx={{ bgcolor: "#003366", "&:hover": { bgcolor: "#002244" } }}
                >
                  Confirm
                </Button>
              </DialogActions>
            </Dialog> */}
          </>
        );
      },
    },

    {
      field: "billingCycle",
      headerName: `Billing Cycle`,
      renderCell: (cellValues) => {
        const billingCycle = cellValues?.row?.billingInfo?.billingCycle;
        return billingCycle;
      },
      flex: 1.2,
      valueGetter: getBillingCycle,
      hide: true,
      disableColumnSelector: true,
      hideable: false,
    },
    {
      field: "paymentDuePeriodDays",
      headerName: `Payment Due Period`,
      renderCell: (cellValues) => {
        const billingCycle = cellValues?.row?.billingInfo?.paymentDuePeriodDays;
        return billingCycle;
      },
      flex: 1.2,
      valueGetter: getPaymentDuePeriod,
      hide: true,
      disableColumnSelector: true,
      hideable: false,
    },

    {
      field: "bufferDays",
      headerName: `Buffer Days`,
      renderCell: (cellValues) => {
        const billingCycle = cellValues?.row?.billingInfo?.bufferDays;
        return billingCycle;
      },
      flex: 1.2,
      valueGetter: getBufferDays,
      hide: true,
      disableColumnSelector: true,
      hideable: false,
    },

    {
      field: "creditThresholdPercent",
      headerName: `Credit Threshold (%)`,
      renderCell: (cellValues) => {
        const billingCycle = cellValues?.row?.creditThresholdPercent;
        return billingCycle;
      },
      flex: 1.2,
      valueGetter: getCreditThreshold,
      hide: true,
      disableColumnSelector: true,
      hideable: false,
    },

    {
      field: "tds",
      headerName: `TDS (%)`,
      renderCell: (cellValues) => {
        const tdsData = cellValues?.row?.tds;
        return tdsData;
      },
      flex: 1.2,
      valueGetter: getTDS,
      hide: true,
      disableColumnSelector: true,
      hideable: false,
    },

    {
      field: "latePaymentFeePercent",
      headerName: `Late Payment Fee (%)`,
      renderCell: (cellValues) => {
        const billingCycle = cellValues?.row?.latePaymentFeePercent;
        return billingCycle;
      },
      flex: 1.2,
      valueGetter: getLatePaymentFee,
      hide: true,
      disableColumnSelector: true,
      hideable: false,
    },

    {
      field: "serviceFeePercent",
      headerName: `Service Fee (%)`,
      renderCell: (cellValues) => {
        const billingCycle = cellValues?.row?.billingInfo?.serviceFeePercent;
        return billingCycle;
      },
      flex: 1.2,
      valueGetter: getServiceFee,
      hide: true,
      disableColumnSelector: true,
      hideable: false,
    },
    {
      field: "platformFeePercent",
      headerName: `Platform Fee (%)`,
      renderCell: (cellValues) => {
        const billingCycle = cellValues?.row?.billingInfo?.platformFeePercent;
        return billingCycle;
      },
      flex: 1.2,
      valueGetter: getPlatformFee,
      hide: true,
      disableColumnSelector: true,
      hideable: false,
    },

    // for postpaid this field
    {
      field: "creditLimit",
      headerName: `Credit Limit`,
      renderCell: ({ row }) => {
        const isPostpaid = row?.billingInfo?.billingMode === "POSTPAID";
        return (
          <>
            {isPostpaid ? (
              <>
                <span>{row.creditLimit || "0"}</span>

                <EditCreditLimitDialog
                  handleConfirmation={(formData) => {
                    handleEditJobDetail(formData);
                  }}
                  _id={row._id}
                  creditLimit={row.creditLimit}
                  render={(handlePopupOpen) => (
                    <IconButton
                      aria-label="edit"
                      size="small"
                      style={{ padding: 4, marginTop: -4, fontSize: 16 }}
                    >
                      <Edit fontSize="small" onClick={handlePopupOpen} />
                    </IconButton>
                  )}
                />
              </>
            ) : (
              <span>NA</span>
            )}
          </>
        );
        //   return (
        //   <>
        //     {row.creditLimit ? (
        //       <>
        //         <span>{row.creditLimit}</span>
        //         <EditCreditLimitDialog
        //           handleConfirmation={(formData) => {
        //             handleEditJobDetail(formData);
        //           }}
        //           _id={row._id}
        //           creditLimit={row.creditLimit}
        //           render={(handlePopupOpen) => (
        //             <IconButton
        //               aria-label="edit"
        //               size="small"
        //               style={{ padding: 4, marginTop: -4, fontSize: 16 }}
        //             >
        //               <Edit fontSize="small" onClick={handlePopupOpen} />
        //             </IconButton>
        //           )}
        //         />
        //       </>
        //     ) : (
        //       <span>NA</span>
        //     )}
        //   </>
        // )
      },

      flex: 1.2,
      valueGetter: getLimit,
    },
    {
      field: "utilizedLimit",
      headerName: `Credit Utilized`,
      renderCell: (cellValues) => {
        // console.log("1--->", cellValues)
        // let amount = "NA";

        let remainingLimit = cellValues?.row?.utilizedLimit;
        // const isPostpaid = cellValues?.billingInfo?.billingMode === "POSTPAID";
        if (cellValues?.row?.billingInfo?.billingMode === "PREPAID") {
          return "NA";
        } else {
          return remainingLimit;
        }

        // return remainingLimit;
        // if (amount) {
        //   return `${amount}`;
        // } else {
        //   amount = "NA";
        //   return `${amount}`;
        // }
      },
      flex: 1.2,
      valueGetter: getRLimit,
    },

    {
      field: "creditNote",
      headerName: `Credit Note`,
      renderCell: ({ row }) => {
        const isPostpaid = row?.billingInfo?.billingMode === "POSTPAID";

        // If NOT postpaid → Show NA only
        if (!isPostpaid) {
          return <span>NA</span>;
        }

        return (
          <>
            <span>{row.creditNote}</span>
            <EditCreditNoteDialog
              handleConfirmation={(formData) => {
                handleEditCreditNoteDetail(formData);
              }}
              _id={row._id}
              creditNote={row.creditNote}
              render={(handlePopupOpen) => (
                <IconButton
                  aria-label="edit"
                  size="small"
                  style={{ padding: 4, marginTop: -4, fontSize: 16 }}
                >
                  <Edit fontSize="small" onClick={handlePopupOpen} />
                </IconButton>
              )}
            />
          </>
        );
      },
      flex: 1.2,
      valueGetter: getCreditNote,
    },

    {
      field: "creditRemaining",
      headerName: ` Credit Remaining`,
      renderCell: (cellValues) => {
        // console.log("1--->", cellValues)
        // let amount = "NA";
        let creditLimit = cellValues?.row?.creditLimit;
        let utilizedLimit = cellValues?.row?.utilizedLimit;
        let creditNote = cellValues?.row?.creditNote;
        let remainingAmount = creditLimit - utilizedLimit + creditNote;
        if (cellValues?.row?.billingInfo?.billingMode === "PREPAID") {
          return "NA";
        }
        {
          return remainingAmount;
        }
      },
      flex: 1,
      valueGetter: getRemainingAmount,
    },

    // for prepaid this field
    {
      field: "amountAvailable",
      headerName: `Amount Available`,
      renderCell: (cellValues) => {
        // console.log("1--->", cellValues);
        // let amount = "NA";
        let amountDeposit = cellValues?.row?.prepaidWallet?.amountAvailable;
        if (cellValues?.row?.billingInfo?.billingMode === "POSTPAID") {
          return "NA";
        } else {
          return amountDeposit;
        }
      },
      flex: 1,
      valueGetter: getRemainingAmount,
    },
    {
      field: "amountUsed",
      headerName: `Amount Used`,
      renderCell: (cellValues) => {
        // console.log("1--->", cellValues);
        // let amount = "NA";
        let amountUsed = cellValues?.row?.prepaidWallet?.amountUsed;
        if (cellValues?.row?.billingInfo?.billingMode === "POSTPAID") {
          return "NA";
        } else {
          return amountUsed;
        }
      },
      flex: 1,
      valueGetter: getRemainingAmount,
    },
    {
      field: "thresholdValue",
      headerName: `Threshold Balance`,
      renderCell: (cellValues) => {
        const thresholdValue = cellValues?.row?.prepaidWallet?.thresholdValue;
        if (cellValues?.row?.billingInfo?.billingMode === "POSTPAID") {
          return "NA";
        } else {
          return thresholdValue;
        }
      },
      flex: 1,
      valueGetter: getRemainingAmount,
    },
    {
      field: "thresholdValueUsed",
      headerName: `Threshold Utilised`,
      renderCell: (cellValues) => {
        const thresholdValueUsed = cellValues?.row?.prepaidWallet?.thresholdValueUsed;
        if (cellValues?.row?.billingInfo?.billingMode === "POSTPAID") {
          return "NA";
        } else {
          return thresholdValueUsed;
        }
      },
      flex: 1,
      valueGetter: getRemainingAmount,
    },

    // {
    //   field: "tds",
    //   headerName: `TDS`,
    //   renderCell: ({ row }) => (
    //     <>
    //       {row.tds ? (
    //         <>
    //           <span>{row.tds}%</span>
    //           <EditTDSDialog
    //             handleConfirmation={(formData) => {
    //               handleEditTDSDetail(formData);
    //             }}
    //             _id={row._id}
    //             tds={row.tds}
    //             render={(handlePopupOpen) => (
    //               <IconButton
    //                 aria-label="edit"
    //                 size="small"
    //                 style={{ padding: 4, marginTop: -4, fontSize: 16 }}
    //               >
    //                 <Edit fontSize="small" onClick={handlePopupOpen} />
    //               </IconButton>
    //             )}
    //           />
    //         </>
    //       ) : (
    //         <span>NA</span>
    //       )}
    //     </>
    //   ),

    //   flex: 1.2,
    //   valueGetter: getTDS,
    // },

    {
      field: "credits",
      headerName: `Action`,
      disableExport: true,
      renderCell: ({ row }) => {
        console.log("ROw===",row);
        
            const rowId = row?._id;
        return (
          <>
          <IconButton
            aria-label="view"
            size="small"
            onClick={() => {
              setSelectedRow(row);
              setOpenModal(true);
            }}
          >
            <VisibilityIcon fontSize="small" />
          </IconButton>
            <IconButton
            component={Link}
  to={`/creditLimit/creditLimit/managecredits/${rowId}`}
  aria-label="manage-credits"
  size="small"
          >
            <AccountBalanceWalletIcon fontSize="small" />
          </IconButton>
          </>
        );
      },
      flex: 1,
    },

    {
      field: "createdAt",
      headerName: `Created At`,
      renderCell: (cellValues) => {
        var a;
        var rowName = cellValues?.row?.createdAt;
        if (rowName) {
          a = moment(rowName).format("YYYY/MM/DD");
          return `${a}`;
        } else {
          a = "NA";
          return `${a}`;
        }
      },
      type: "date",

      valueGetter: getCreatedAT,
    },
    {
      field: "updatedAt",
      headerName: `Updated At`,
      renderCell: (cellValues) => {
        var a;
        var rowName = cellValues?.row?.updatedAt;
        if (rowName) {
          a = moment(rowName).format("YYYY/MM/DD");
          return `${a}`;
        } else {
          a = "NA";
          return `${a}`;
        }
      },
      type: "date",

      valueGetter: getUpdatedAT,
    },
  ];

  const handleEditJobDetail = async (formData) => {
    // console.log("formData>>", formData)
    const { _id, creditLimit, creditNote } = formData;

    try {
      // Dispatch an action to update credit limit in the backend
      const response = await dispatch(
        UpdateHospital({ id: _id, payload: { creditLimit, creditNote } })
      );
      if (response && response.error) {
        console.error("Failed to update credit limit:", response.error);
      } else {
        dispatch(HospitalBranchList([]));
        // console.log("Credit limit updated successfully");
      }
    } catch (error) {
      console.error("Error updating credit limit:", error);
    }
  };

   const handleEditCreditNoteDetail = async (formData) => {
     // console.log("formData>>", formData)
     const { _id, creditNote } = formData;

     try {
       // Dispatch an action to update credit limit in the backend
       const response = await dispatch(
         UpdateHospital({ id: _id, payload: { creditNote } })
       );
       if (response && response.error) {
         console.error("Failed to update credit limit:", response.error);
       } else {
         dispatch(HospitalBranchList([]));
         // console.log("Credit limit updated successfully");
       }
     } catch (error) {
       console.error("Error updating credit limit:", error);
     }
   };

  const handleEditTDSDetail = async (formData) => {
    // console.log("formData>>", formData)
    const { _id, tds } = formData;

    try {
      // Dispatch an action to update credit limit in the backend
      const response = await dispatch(
        UpdateHospital({ id: _id, payload: { tds } })
      );
      if (response && response.error) {
        console.error("Failed to update credit limit:", response.error);
      } else {
        dispatch(HospitalBranchList([]));
        // console.log("Credit limit updated successfully");
      }
    } catch (error) {
      console.error("Error updating credit limit:", error);
    }
  };

  // const handleSaveChanges = () => {
  //   const updatedData = {
  //     creditThresholdPercent: creditThreshold,
  //     tds,
  //     latePaymentFeePercent: lateFee,
  //   };

  //   // Call API or update state here
  //   console.log("Saving:", updatedData);
  //   setOpenModal(false);
  // };

  const handleSaveChanges = async (formData) => {
    // console.log("formData>>", formData);
    const {
      _id,
      creditThresholdPercent,
      tds,
      latePaymentFeePercent,
      billingCycle,
      paymentDuePeriodDays,
      bufferDays,
      platformFeePercent,
      thresholdValue,
    } = formData;

    try {
      const response = await dispatch(
        UpdateHospital({
          id: _id,
          payload: {
            creditThresholdPercent,
            tds,
            latePaymentFeePercent,
            billingInfo: {
              billingCycle,
              paymentDuePeriodDays,
              bufferDays,
              platformFeePercent,
            },
            prepaidWallet: {
              thresholdValue,
            },
          },
        })
      );

      if (response && response.error) {
        console.error("Failed to update details:", response.error);
      } else {
        dispatch(HospitalBranchList([])); // refresh table data
      }
    } catch (error) {
      console.error("Error saving details:", error);
    }
  };

  const [isOpen, setisOpen] = useState(false);

  useEffect(() => {
    if (state?.data) {
      setisOpen(true);
    }
  }, [state]);

  const { hospital_branch_Data } = useSelector((state) => state.hospital);

  let BranchData = hospital_branch_Data?.branchInfo;
  //   console.log("---->", BranchData);

  useEffect(() => {
    dispatch(HospitalBranchList([]));
  }, []);

  function formatDate() {
    const now = new Date();

    const day = String(now.getDate()).padStart(2, "0");

    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const month = monthNames[now.getMonth()];
    const year = now.getFullYear();

    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");

    const formattedDate = `${day} ${month} ${year}_${hours}_${minutes}_${seconds}`;

    return formattedDate;
  }
  //  console.log("columns", columns);
  return (
    <DashboardLayout>
      {" "}
      <DashboardNavbar />
      <FilterBar
        title1="Credit Limit"
        showDialog={false}
        showisDeleted={false}
      />{" "}
      <MDBox sx={{ marginTop: "2rem" }}>
        {" "}
        <DataGrid
          getRowId={(row) => row._id}
          // components={{ Toolbar: GridToolbar }}
          components={{
            Toolbar: (props) => {
const hasExportPermission =adminData?.isSuperAdmin || adminData?.permissions?.some(
(item) => item.module === "credit_limit" && item.actions.includes("export")
);
              return (
                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px' }}>
               
                  <div>
                    <GridToolbarColumnsButton {...props} />
                    <GridToolbarFilterButton {...props} />
                    <GridToolbarDensitySelector {...props} />
                    
                    <GridToolbarExport
                      {...props} 
                      disabled={!hasExportPermission}
                    />
                  </div>
        
                     <div>
                    <GridToolbarQuickFilter {...props} />
                  </div>
                </div>
              );
            }
          }}
          componentsProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 500 },
              printOptions: { disableToolbarButton: true },
              csvOptions: {
                fileName: `CreditLimit-${formatDate()}`,
                fields: [
                  "_id",
                  "branchName",
                  "billingMode",
                  "billingCycle",
                  "paymentDuePeriodDays",
                  "bufferDays",
                  "creditThresholdPercent",
                  "tds",
                  "latePaymentFeePercent",
                  "serviceFeePercent",
                  "platformFeePercent",
                  "creditLimit",
                  "utilizedLimit",
                  "creditNote",
                  "creditRemaining",
                  "createdAt",
                  "updatedAt",
                ],
              },

              // csvOptions: {
              //   fileName: `CreditLimit-${formatDate()}`,
              // },
            },
          }}
          // initialState={{
          //   columns: {
          //     columnVisibilityModel: {
          //       billingCycle: false,
          //     },
          //   },
          // }}
          columns={columns}
          rows={[...BranchData].reverse()}
          pagination
          pageSize={100}
          rowsPerPageOptions={[100]}
          //isRowSelectable
          sx={{
            backgroundColor: "#ffff",
            color: "grey",
            height: "35rem",
            margin: "1rem",
            borderRadius: "0.5rem",
            "& .MuiDataGrid-cell": {
              padding: "15px",
              fontSize: "12px",
            },
            borderColor: "light-grey",
            "& .MuiDataGrid-cell:hover": {
              color: "info",
            },
          }}
        />{" "}
      </MDBox>{" "}
      <div>
        <DetailsDialog
          open={openModal}
          onClose={() => setOpenModal(false)}
          selectedRow={selectedRow}
          onSave={handleSaveChanges}
        />
      </div>
    </DashboardLayout>
  );
};
export default LocumCreditLimit;
